import { render } from "./ContentPdf.vue?vue&type=template&id=6e8cd126"
import script from "./ContentPdf.vue?vue&type=script&lang=js"
export * from "./ContentPdf.vue?vue&type=script&lang=js"

import "./ContentPdf.vue?vue&type=style&index=0&id=6e8cd126&scope=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__